module.exports = __webpack_public_path__ + "img/传统生产2.f14974f6.png";